import { gsap } from "gsap"

jQuery(initSidebarAnimations)

function initSidebarAnimations() {
  functionalShineAnimation()
  technicalShineAnimation()
}

// FUNCTIONAL SERVICES
function functionalShineAnimation() {
  jQuery(".functional-services-card-sidebar").each(function () {
    const $sidebar = jQuery(this)
    let $shine = $sidebar.find(".shine")

    // shine
    gsap.set($shine, {
      position: "absolute",
      left: "50%",
      top: "-56px",
      width: "100%",
      height: "56px",
      transform: "translateX(-50%)",
      background:
        "radial-gradient(ellipse at center, rgba(255,255,255,0.58) 0%, rgba(171,206,254,0.23) 60%, rgba(85,157,255,0) 100%)",
      pointerEvents: "none",
      zIndex: 10,
      opacity: 0.6,
    })

    // animazione
    gsap.to($shine, {
      top: "100%",
      opacity: 0,
      duration: 2.4,
      repeat: -1,
      ease: "linear",
      keyframes: [
        { top: "-56px", opacity: 0.6 },
        { top: "25%", opacity: 1 },
        { top: "75%", opacity: 1 },
        { top: "100%", opacity: 0 },
      ],
    })
  })
}

// TECHNICAL SERVICES
function technicalShineAnimation() {
  jQuery(".technical-services-card-sidebar").each(function () {
    const $sidebar = jQuery(this)
    let $shine = $sidebar.find(".shine")

    // shine
    gsap.set($shine, {
      position: "absolute",
      top: "50%",
      left: "-56px",
      width: "56px",
      height: "100%",
      transform: "translateY(-50%)",
      background:
        "radial-gradient(ellipse at center, rgba(255,255,255,0.58) 0%, rgba(171,206,254,0.23) 60%, rgba(85,157,255,0) 100%)",
      pointerEvents: "none",
      zIndex: 5,
      opacity: 0.6,
    })

    // animazione
    gsap.to($shine, {
      left: "100%",
      opacity: 0,
      duration: 2.4,
      repeat: -1,
      ease: "linear",
      keyframes: [
        { left: "-56px", opacity: 0.6 },
        { left: "25%", opacity: 1 },
        { left: "75%", opacity: 1 },
        { left: "100%", opacity: 0 },
      ],
    })
  })
}
